(function() {
	"use strict";
	/**
	*	Plus 3 Interactive HTML building directive
	*
	*	Interpolates an html string and compiles it against parent scope
	*/
	angular
		.module("P3in")
		.directive("p3BindHtml", p3BindHtml);

	p3BindHtml.$inject = ["$compile", "$sce", "$parse"];

	function p3BindHtml($compile, $sce, $parse) {
		return {
			restrict: "AE",
			priority: 1000,
			scope: true,
			link: function(scope, ele, attrs) {
				scope.value = attrs.value;
				scope.altParam = attrs.altParam;
				scope.$watch(attrs.p3BindHtml, function() {
					ele.html($parse(attrs.p3BindHtml)(scope))
					$compile(ele.contents())(scope);
				})
			}
		}
	}
})()


// WEBPACK FOOTER //
// ./src/app/modules/P3in/directives/p3BindHtml.js